export default function() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent) && userAgent.match(/version\/[\d\.]+.*safari/)
}
